import React, { useCallback } from 'react';
import { Button, Dialog } from 'antd-mobile';
import lookie from 'lookie';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentServingOrder } from '@/store/service';
import { handleNavFromOrderInfo, Toast } from '@/utils';
import useNav from '@/hooks/useNav';
import { CURRENT_ORDER_ID, MASSAGE_SETTING_CACHE, MassageType2Text } from '@/constant';
import { selectedIsCanNavToMassageControl } from '@/store/device';
import service from '@/service';
import cx from './index.module.scss';

interface Props {
  onEndService: (orderId: string) => void;
}

const IsServicing: React.FC<GetServingOrderResponse & Props> = props => {
  const { productItems, productName, createTime, orderId, onEndService, step } = props;
  const dispatch = useDispatch();

  const isCanNavToMassageControl = useSelector(selectedIsCanNavToMassageControl);
  const nav = useNav();
  // 继续服务
  const handleContinueService = useCallback(async () => {
    const { data } = await service.service.getServingOrderByOperator();

    if (!data) {
      Toast.show('当前订单已结束');
      lookie.remove(CURRENT_ORDER_ID);
      onEndService?.(orderId);
      dispatch(setCurrentServingOrder({} as any));
      return;
    }

    if (step === 'RoboticTask' && !isCanNavToMassageControl) {
      return;
    }
    handleNavFromOrderInfo(props, nav);
  }, [dispatch, isCanNavToMassageControl, nav, onEndService, orderId, props, step]);

  // 结束服务
  const handleEndService = useCallback(
    async e => {
      e.stopPropagation();
      Dialog.confirm({
        title: '确定要结束服务吗？',
        content: '确认后将直接结束服务',
        confirmText: '确认结束',
        async onConfirm() {
          try {
            await service.massage.quitMassage({
              serviceOrderId: orderId,
              terminate: true,
            });
            lookie.remove(CURRENT_ORDER_ID);
            lookie.remove(MASSAGE_SETTING_CACHE);
            dispatch(setCurrentServingOrder({} as any));
            Toast.success('结束服务成功');
            onEndService?.(orderId);
          } catch (e) {
            console.error(e);
          }
        },
      });
    },
    [dispatch, onEndService, orderId]
  );

  return (
    <div className={cx('is-servicing')} onClick={handleContinueService}>
      <div className={cx('left')}>
        <div className={cx('header')}>
          <div className={cx('treat-info-productName')}>{productName}</div>
          {productItems?.map((item, index) => (
            <div key={'type-' + index} className={cx('treat-info-type', item + '-tags')}>
              {MassageType2Text[item]}
            </div>
          ))}
        </div>
        <div className={cx('create-time')}>服务创建时间：{createTime}</div>
      </div>

      <div className={cx('right')}>
        <div className={cx('btns')}>
          <Button color="danger" className={cx('btn', 'danger')} onClick={handleEndService}>
            结束服务
          </Button>
          <Button color="primary" className={cx('btn', 'primary')}>
            继续服务
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IsServicing;
